import { useContext } from "react";

import { BaseBenefitsList } from "../../BaseComponents/BaseBenefitsList";
import { BaseCompanyLogo } from "../../BaseComponents/BaseCompanyLogo";
import BaseLinkWrapper from "../../BaseComponents/BaseLinkWrapper";
import { BaseMediaAlphaHeadline } from "../../BaseComponents/BaseMediaAlphaHeadline";
import BaseReviewLink from "../../BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../BaseComponents/BaseServiceFlag";
import { BaseVisitLink } from "../../BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../CompanyList/CompanyContext";
import { getStyles } from "./styles";

export const InsuranceListCompany = () => {
	const { companyIndex } = useContext(CompanyContext);

	const styles = getStyles({ companyIndex });

	return (
		<div
			className={`tw-relative tw-mx-auto tw-mt-4 tw-flex tw-max-w-[500px] tw-flex-col tw-flex-wrap tw-py-5 [border-bottom:1px_solid_#f2f3f4] lg:tw-max-w-none lg:tw-flex-row lg:tw-py-4`}
		>
			<BaseServiceFlag classNames={styles.serviceFlag} />

			<div className="tw-flex tw-w-full lg:tw-w-1/4">
				<BaseLinkWrapper className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-center">
					<div className="tw-flex tw-w-3/5 tw-items-center tw-justify-between xs2:tw-flex-wrap lg:tw-w-full lg:tw-items-start lg:tw-justify-center">
						<div className="tw-flex tw-w-full tw-max-w-full tw-items-center tw-justify-center tw-text-center md:tw-text-left">
							<BaseCompanyLogo classNames={styles.companyLogo} />
						</div>
					</div>
				</BaseLinkWrapper>
			</div>

			<div className="tw-flex tw-w-full tw-items-center tw-justify-center tw-p-4 lg:tw-w-[55%] lg:tw-justify-start lg:tw-py-0 lg:tw-pl-0 lg:tw-pr-2">
				<div className="tw-flex tw-flex-wrap tw-justify-between lg:tw-flex-nowrap">
					<BaseLinkWrapper>
						<BaseMediaAlphaHeadline className="tw-mb-2 tw-text-lg tw-font-semibold tw-text-black" />
						<BaseBenefitsList {...styles.benefitsList} />
					</BaseLinkWrapper>
				</div>
			</div>

			<div className="tw-flex tw-w-full tw-flex-col tw-flex-wrap tw-items-center tw-justify-center lg:tw-w-1/5">
				<BaseLinkWrapper className="tw-relative tw-inline-flex tw-h-[46px] tw-w-[180px] tw-max-w-[210px] tw-items-center tw-justify-center tw-rounded-[3px] tw-bg-[#1d8ce0] tw-font-[AvenirNextLTPro-Demi] tw-text-[1.25rem] tw-font-bold tw-leading-[1] tw-text-white after:tw-ml-[10px] after:tw-block after:tw-h-[16px] after:tw-w-[16px] after:tw-bg-[url(/public/react-images/common/newTab.svg)] after:tw-bg-cover after:tw-bg-no-repeat xs2:tw-max-w-[initial]">
					<BaseVisitLink>View Rates</BaseVisitLink>
				</BaseLinkWrapper>

				<BaseReviewLink classNames={styles.reviewLink} linkText="Read Review" />
			</div>
		</div>
	);
};
